/**
 * @file  popover浮层组件
 * @author liudy
 */

import React, { Component } from 'react';

import './menu.scss';

export interface IProps {
    cls?: string;
}

export default class Menu extends Component<IProps, {}> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        const { cls, children } = this.props;
        return (
            <ul className={`menu-list ${cls || ''}`}>
                {children}
            </ul>
        );
    }
}
